import { useEffect } from 'react';
import VersionManager from '../utils/versionManager';

// Hook para trackear automáticamente cambios y actualizar versión
export const useVersionTracking = () => {
  
  const trackAction = (action: string, details?: string) => {
    console.log(`📝 Acción registrada: ${action}${details ? ` - ${details}` : ''}`);
    VersionManager.trackUserAction(action);
  };

  const trackContactAction = (action: 'create' | 'update' | 'delete', contactName?: string) => {
    trackAction(`${action}_contact`, contactName);
  };

  const trackCompanyAction = (action: 'create' | 'update' | 'delete', companyName?: string) => {
    trackAction(`${action}_company`, companyName);
  };

  const trackMeetingAction = (action: 'create' | 'update' | 'delete', meetingTitle?: string) => {
    trackAction(`${action}_meeting`, meetingTitle);
  };

  const trackActivityAction = (action: 'create' | 'update' | 'delete', activityType?: string) => {
    trackAction(`${action}_activity`, activityType);
  };

  const trackFormAction = (action: 'create' | 'update' | 'delete', formName?: string) => {
    trackAction(`${action}_form`, formName);
  };

  const trackUserAction = (action: 'create' | 'update' | 'delete', userName?: string) => {
    trackAction(`${action}_user`, userName);
  };

  const trackCollaboratorAction = (action: 'create' | 'update' | 'delete', collaboratorName?: string) => {
    trackAction(`${action}_collaborator`, collaboratorName);
  };

  const trackProjectAction = (action: 'create' | 'update' | 'delete', projectName?: string) => {
    trackAction(`${action}_project`, projectName);
  };

  const trackTimesheetAction = (action: 'create' | 'approve' | 'reject', collaboratorName?: string) => {
    trackAction(`${action}_timesheet`, collaboratorName);
  };

  const trackInvoiceAction = (action: 'create' | 'validate', invoiceNumber?: string) => {
    trackAction(`${action}_invoice`, invoiceNumber);
  };

  const trackPaymentAction = (collaboratorName?: string) => {
    trackAction('create_payment', collaboratorName);
  };

  const trackSettingsAction = (section?: string) => {
    trackAction('update_settings', section);
  };

  const trackEmailTemplateAction = (action: 'create' | 'update' | 'delete', templateName?: string) => {
    trackAction(`${action}_email_template`, templateName);
  };

  return {
    trackContactAction,
    trackCompanyAction,
    trackMeetingAction,
    trackActivityAction,
    trackFormAction,
    trackUserAction,
    trackCollaboratorAction,
    trackProjectAction,
    trackTimesheetAction,
    trackInvoiceAction,
    trackPaymentAction,
    trackSettingsAction,
    trackEmailTemplateAction,
    trackAction
  };
};